import React from "react";

const AuthLayout = ({ children }) => {
  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthLayout;
